<template>
  <div class="yxtbiz-ai-robot__dialog" :class="{'fullscreen-dialog': bFullscreen }">
    <!-- 对话框头部 -->
    <div class="yxtbiz-ai-robot__dialog--header">
      <div class="yxtbiz-ai-robot__dialog--header-left">
        <yxtf-portrait v-if="!bFullscreen && settings.assistHeadImg" class="mr12" size="small" username="AI" :imgUrl="settings.assistHeadImg" />
        <span v-if="!bFullscreen">{{ title }}</span>
      </div>
      <div class="yxtbiz-ai-robot__dialog--header-right">
        <yxtf-popconfirm
          v-if="!bFullscreen"
          :title="$t('pc_biz_ai_log_clear_confirm').d('确定清空此对话消息记录？')"
          hide-icon
          @confirm="clearHistory"
        >
          <header-icon slot="reference" class="mr16" :size="iconSize" icon-name="clear" :pop-text="$t('pc_biz_ai_clear_log').d('清空记录')" remote />
        </yxtf-popconfirm>
        <header-icon  v-if="!bFullscreen" class="mr16" :size="iconSize" @click="share" icon-name="share" :pop-text="$t('pc_biz_ai_share').d('分享')" remote/>
        <Share  v-if="showShare && !bFullscreen" />
        <template v-if="!max">
          <header-icon
            class="mr16"
            remote
            :size="iconSize"
            @click="changeFullSize"
            :icon-name="bFullscreen ? 'window' : 'fullscreen'"
            :pop-text="bFullscreen ? $t('pc_biz_ai_small_window').d('小窗口') : $t('pc_biz_ai_full_screen').d('全屏')"
          />
          <!-- 已有的关闭icon尺寸比设计图的小2px -->
          <header-icon class="mr16" remote :size="iconSize" @click="$emit('close')" icon-name="ai-close" :pop-text="$t('pc_biz_ai_close').d('关闭')" />
        </template>
      </div>
    </div>
    <!-- 对话框主体 -->
    <div class="yxtbiz-ai-robot__dialog--body" :style="aiBodyStyle">
      <yxtf-scrollbar class="yxtbiz-ai-robot-scrollbar" ref="scrollbar" :fit-height="true">
        <infinite-scroll v-if="!noMoreHistory" :element="$refs.dialogBody" @more="getHistory"></infinite-scroll>
        <ul ref="dialogBody" class="is-msg-list">
          <li
            v-for="(msg, index) in msgList"
            :key="index"
            :class="{ 'yxtbiz-ai-robot__dialog--msg-question': msg.type }"
          >
            <Message :msg="msg" :lastMsg="index === (msgList.length - 1)" :isWaitAnswer="isWaitAnswer" :fullscreen="bFullscreen" @feedback="showFeedbackDialog(index)"  @promot="onPromot"  @resend="(val) => resend(msg, val, index)"  @scrollToEnd="scrollToEnd"></Message>
          </li>
        </ul>
      </yxtf-scrollbar>
    </div>
    <!-- 底部输入框 -->
    <div class="yxtbiz-ai-robot__dialog--footer" ref="aiFooter">
      <div :class="{'textarea-content': true, 'textarea-focus': focus, 'more-lines': inputHeight > 53  }">
        <span class="stop-answer" v-if="isWaitAnswer" @click="stopAIAnswer()">
          <span class="block"></span>
          <span> {{ '停止回答'  }}</span>
        </span>
        <textarea :class="{'no-question': !question}" ref="textarea" v-model="question"  maxlength="2000" :placeholder="$t('pc_biz_ai_input_problem').d('请输入您要咨询的问题')" @keydown="keydown" @focus="focus = true" @blur="focus = false"></textarea>
        <div :class="{'ai-robot-btn-send': true, 'disbale-send': isWaitAnswer}" v-if="question" @click="sendMsg"><img :src="sendSvg"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  submitQuestion,
  questionHistory,
  submitQuestionFeedback,
  clearHistory,
  getAskReqId,
  stopQuestion,
  todayIsVisit,
  getStaticBaseUrl
} from '../service';
import Message from './message.vue';
import HeaderIcon from './headerIcon.vue';
import InfiniteScroll from './infiniteScroll.vue';
import Share from './share.vue';

export default {
  name: 'MsgDialog',
  components: {
    InfiniteScroll,
    Message,
    HeaderIcon,
    Share
  },
  props: {
    max: {
      type: Boolean,
      default: false
    },
    sid: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default() {
        return this.$t('pc_biz_ai_title').d('企业AI助手');
      }
    },
    visible: {
      type: Boolean,
      default: false
    },
    bFullscreen: {
      type: Boolean,
      default: false
    }
  },
  inject: ['settings'],
  data() {
    return {
      sendSvg: `${getStaticBaseUrl()}ufd/407a24/assistent/pc/svg/send.svg`,
      stopAnswerList: {}, // 待停止的回答队列ID集合
      wrapClass: ['custom-wrap'],
      isfirstLoad: true,
      maxCreateTime: '',
      focus: false,
      excludeIds: [],
      resendMsg: null,
      showShare: false,
      isWaitAnswer: false,
      offsetY: 0,
      sBodyHeight: 120, // 窗体初始化的差值，窗体拖拉会用到该值计算
      inputHeight: 52, // 输入框高度
      question: '',
      askQuestion: '',
      msgList: [],
      askHistory: [],
      currentFeedbackIndex: 0,
      noMoreHistory: !this.sid // 无更多历史消息
    };
  },
  computed: {
    aiBodyStyle() {
      return { height: 'calc( 100% - ' + (this.inputHeight + 92) + 'px )' };
    },
    iconSize() {
      return this.bFullscreen ? 24 : 20;
    },
    closeIconSize() {
      const size = this.bFullscreen ? 26 : 22;
      return `${size}px`;
    }
  },
  watch: {
    question: function(val) {
      this.$nextTick(() => {
        this.resizeTextarea();
      });
    }
  },
  created() {
    // 默认提问消息
    this.msgList = [{
      chatType: 1,
      answerStatus: 3
    }];
  },
  mounted() {
    document.body.addEventListener('click', () => {
      this.showShare = false;
    });
  },
  methods: {
    async stopAIAnswer() {
      // 获取队列中最新条的key
      let lastKey = Object.keys(this.stopAnswerList)[Object.keys(this.stopAnswerList).length - 1];
      console.log(lastKey);
      this.stopAnswerList[lastKey] = true;
      this.isWaitAnswer = false;
      let { answerStatus, contentDetail } = this.msgList[this.msgList.length - 1]; // 数组最后一项
      await stopQuestion({askReqId: lastKey, stopText: contentDetail && contentDetail.content || '已停止回答'});
      let stopMessage = {
        chatType: 1,
        answerStatus: 3,
        contentDetail: {
          content: '已停止回答', // 拼接消息体
          linkList: []
        }
      };
      if (answerStatus === 0) { // 如果在回答中
        this.msgList.pop();
        this.msgList.push(stopMessage);
      }
      this.$nextTick(() => {
        this.scrollToEnd();
      });
    },
    // 自适应输入框调整
    resizeTextarea(e) {
      const textarea = this.$refs.textarea;
      textarea.style.height = 52 + 'px';
      if (textarea.scrollHeight > 52) {
        this.inputHeight = Math.min(textarea.scrollHeight + 10, 165);
        textarea.style.height = this.inputHeight + 'px';
      } else {
        this.inputHeight = textarea.scrollHeight;
      }
    },
    // 获取历史消息
    getHistory() {
      const dialogBody = this.$refs.dialogBody;
      const offsetH = dialogBody.offsetHeight;
      this.msgList.unshift({ // 舔加加载历史等待效果
        answerStatus: 0,
        chatType: 1
      });
      // TODO: 接口对接
      questionHistory({
        excludeIds: this.excludeIds,
        askSessionId: this.sid,
        maxCreateTime: this.maxCreateTime
      }).then(async res => {
        this.msgList.shift(); // 清除首位置添加的等待效果
        if (res && res.list && res.list.length) {
          // 格式化消息记录消息体
          let chatLog = res.list;
          chatLog.reverse(); // 聊天记录顺序反转一次
          this.msgList.unshift(...chatLog); // 拼接历史消息记录
          this.$nextTick(() => { // 滑动效果
            this.scrollTo(dialogBody.offsetHeight - offsetH);
          });
          if (res.excludeIds && res.excludeIds.length) { // 如果还有更多历史消息
            this.excludeIds = res.excludeIds;
            this.maxCreateTime = res.maxCreateTime;
          }
          if (this.msgList.length < 10) { // 消息总条数少于10条
            this.noMoreHistory = true;
          }
        } else {
          this.noMoreHistory = true;
          if (this.msgList.length > 5) {
            this.msgList.unshift({
              chatType: 2,
              content: this.$t('pc_biz_ai_no_more').d('暂无更多')
            });
          }
        }
        // 判断是否展示提示语
        let IsVisit = await todayIsVisit();
        if (!IsVisit) {
          this.msgList.push({ // 创建默认问候语，问候语不存于聊天记录中
            chatType: 1,
            answerStatus: 4
          });
        }
        if (this.isfirstLoad) {
          this.getQueryAskHistory();
        }
        this.isfirstLoad = false;
      });
    },
    keydown(e) {
      if (e.shiftKey || e.altKey) return;
      if (e.keyCode === 13) {
        e.preventDefault();
        if (e.ctrlKey) {
          console.log('keydown', e);
          this.question += '\n';
        } else {
          this.sendMsg();
        }
      }
    },
    onPromot(val) { // 初始化的试着问一问
      if (this.isWaitAnswer) { // 等待中
        this.$message.warning('暂时不能发送，请稍后再试！');
        return;
      }
      this.question = val;
      this.sendMsg();
    },
    // 重新发送
    resend(msg, resendType, index) {
      for (let i = index; i >= 0; i--) { // 往前找提问消息 找到第一个终止
        if (this.msgList[i] && this.msgList[i].chatType === 0) {
          this.resendMsg = {
            contentDetail: {
              content: this.msgList[i].contentDetail && this.msgList[i].contentDetail.content
            },
            chatType: 0
          };
          if (msg.askInternet) {
            this.sendMsg('askInternet');
          } else {
            this.sendMsg(resendType);
          }
          break;
        }
      }
    },
    async sendMsg(resendType) {
      let self = this;
      // 答案等待中，不可发消息
      self.$emit('getChatSetting'); // 每次发送消息都重新拿一下配置
      // self.stopAnswer = false;
      if (self.isWaitAnswer) { // 等待中
        this.$message.warning(this.$t('pc_biz_ai_send_wait').d('暂时不能发送，请稍后再试！'));
        return;
      }
      let str = this.question.replace(/(^\s*)|(\s*$)/g, '');
      if (!str && !this.resendMsg) {
        this.$message.warning(this.$t('pc_biz_ai_input_not_empty').d('发送内容不能为空！'));
        this.question = '';
        return;
      }
      let { snowId } = await getAskReqId();
      self.stopAnswerList[snowId] = false;
      self.isWaitAnswer = true;
      self.addQuestion();
      // #region 模拟接口返回
      self.addAnswer(); // loadding...
      // TODO: 接口对接
      submitQuestion({
        askContent: (self.resendMsg && self.resendMsg.contentDetail.content) || self.askQuestion,
        askHistory: self.askHistory, // 带上最近的三条记录
        askSessionId: self.sid,
        askReqId: snowId,
        askInternet: resendType === 'askInternet' ? 1 : 0
      }, {
        onmessage: (msg) => {
          if (this.stopAnswerList[snowId]) return;
          let msgData = JSON.parse(msg.data);
          console.log('接收到了消息', msgData);
          if (msgData.type === 0 || msgData.type === 1) { // 进行中
            self.addAnswer({
              answerStatus: msgData.answerStatus ? msgData.answerStatus : 1,
              chatCorrectEnabled: msgData.chatCorrectEnabled || 0, // 是否启用纠错
              chatLikeFlag: msgData.chatLikeFlag || 0, // 是否评价过
              chatContentId: msgData.chatContentId, // 消息id
              askInternet: resendType === 'askInternet' ? 1 : 0,
              askReqId: snowId,
              chatType: 1, // 消息类型 1回答 0 提问
              contentDetail: {
                content: msgData.contentChip || '',
                linkList: msgData.linkList && msgData.linkList.length ? msgData.linkList : (msg.linkList && msg.linkList.length ? msg.linkList : [])
              }
            });
            if (msgData.type === 1) {
              self.getQueryAskHistory({
                answer: self.msgList[self.msgList.length - 1].contentDetail.content,
                ask: self.msgList[self.msgList.length - 2].contentDetail.content
              });
            }
          } else if (msgData.type === 2) {
            if (self.stopAnswerList[snowId]) return;
            self.isWaitAnswer = false;
            if (msgData.errorMsg) {
              self.addAnswer({
                answerStatus: 3, // 错误消息
                chatType: 1, // 消息类型 1回答 0 提问
                contentDetail: {
                  content: msgData.errorMsg || '',
                  linkList: []
                }
              });
            }
          }
          self.$nextTick(() => {
            self.scrollToEnd();
          });
        },
        onclose(msg) {
          if (self.stopAnswerList[snowId]) return;
          if (msg === 'timeout') { // 超时错误
            self.$message.error(self.$t('pc_biz_ai_network_timeout').d('网络超时，请重试！'));
            self.msgList.pop(); // 清除等待消息效果
          }
          if (self.isWaitAnswer) {
            self.isWaitAnswer = false;
          }
          self.resendMsg = null; // 清空重新发送数据
          self.$nextTick(() => {
            self.scrollToEnd();
          });
        },
        onerror(err) {
          if (self.isWaitAnswer) {
            self.isWaitAnswer = false;
          }
          self.resendMsg = null; // 清空重新发送数据
          console.log('onerror', err);
        }
      }).then(res => {
        console.log(res);
      });
    },
    // 提问题
    addAnswer(answer) {
      if (answer) {
        if (this.msgList.length && this.msgList.length > 1) { // 有消息记录
          let lastMessage = this.msgList[this.msgList.length - 1]; // 数组最后一项
          console.log('lastMessage', lastMessage);
          if (lastMessage.chatType && lastMessage.chatContentId && lastMessage.chatContentId === answer.chatContentId) { // 如果是回答id相同则表示内容跟新
            let params = {
              ...answer,
              contentDetail: {
                content: lastMessage.contentDetail.content + answer.contentDetail.content, // 拼接消息体
                linkList: answer.contentDetail.linkList || lastMessage.contentDetail.linkList || []
              }
            };
            this.msgList.splice(this.msgList.length - 1, 1, params);
            console.log('更新消息内容', params);
          } else {
            // 创建新回答
            console.log('创建新消息', answer);
            this.msgList.splice(-1, 1, answer);
          }
        } else { // 无历史消息
          // 加载答案
          this.msgList.splice(-1, 1, answer);
        }
      } else {
        // 加载等待消息
        this.msgList.push({
          answerStatus: 0,
          chatType: 1
        });
      }
      this.$nextTick(() => {
        this.scrollToEnd();
      });
    },
    // 获取查询所需的历史记录
    getQueryAskHistory(newlog) {
      if (newlog) {
        if (this.askHistory.length < 3) {
          this.askHistory.push(newlog);
        } else {
          this.askHistory.push(newlog);
          this.askHistory.shift();
        }
      }
      console.log('this.msgList', this.msgList);

    },
    // 添加提问记录
    addQuestion() { // 添加提问记录
      this.msgList.push(this.resendMsg || {
        chatType: 0,
        contentDetail: {
          content: this.question
        }
      });
      this.askQuestion = this.question;
      // 清空输入框
      this.question = '';
      this.$refs.textarea.height = '52px';
    },
    // 改变全屏尺寸
    changeFullSize() {
      let bFullscreen = !this.bFullscreen;
      this.$emit('fullscreen', bFullscreen);
      this.$nextTick(() => {
        this.scrollToEnd();
      });
    },
    // 分享功能
    share(event) {
      console.log('share');
      this.showShare = !this.showShare;
    },
    // 清空历史记录接口
    clearHistory() {
      clearHistory().then(() => {
        this.msgList = [{
          chatType: 1,
          answerStatus: 3
        }];
        window.localStorage.setItem('sid', '');
      });
    },
    // 展示反馈弹窗
    showFeedbackDialog(index) {
      this.currentFeedbackIndex = index;
      this.$emit('feedback');
    },
    // 更新反馈状态
    updateFeedback(content) {
      submitQuestionFeedback({ chatContentId: this.msgList[this.currentFeedbackIndex].chatContentId, correctContent: content})
        .then(_res => {
          this.$message.success(this.$t('pc_biz_ai_feedback_success').d('感谢您的反馈！'));;
          this.msgList[this.currentFeedbackIndex].chatCorrectEnabled = 1; // 更新反馈状态
        });
    },
    // 滑动到指定元素
    scrollTo(p) {
      const scrollElement = this.$refs.scrollbar && this.$refs.scrollbar.$el.firstChild;
      scrollElement && scrollElement.scrollTo(0, p);
    },
    // 滑动底部
    scrollToEnd() {
      this.$nextTick(() => {
        this.$refs.dialogBody.scrollIntoView({
          block: 'end',
          behavior: 'smooth'
        });
      });
    }
  }
};
</script>
